import { useMemo, useState } from 'react';
import { useStoreActions } from "../../../store/store-context";
import { handlePromise } from "../../../infra/utils";
import { ConfirmationModal, useOverlayContext } from 'seagull';
import { isEqual } from 'lodash-es';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DraftUpdateModal(props) {
  const {
    changeDraftInRow,
    renderContent,
    dismissModal,
    width,
    skin = 'primary',
    shouldSubmit = () => Promise.resolve(true),
    submitOnNotDirty = false
  } = props;
  const [draft, setDraft] = useState(props.draft);
  const [loading, setLoading] = useState(false);
  const [wasSubmitted, setWasSubmitted] = useState(false);
  const {
    api
  } = useStoreActions();
  const {
    showErrorToast
  } = useOverlayContext();
  const isDirty = useMemo(() => !isEqual(draft, props.draft), [draft, props.draft]);
  const {
    title,
    testid,
    content,
    onSubmit,
    primaryButtonLabel = 'Save'
  } = renderContent({
    wasSubmitted,
    draft,
    setDraft
  });
  async function submit() {
    setWasSubmitted(true);
    if (!(await shouldSubmit(draft))) return;
    setLoading(true);
    const result = await handlePromise(api.draft.save(draft.toDTO()));
    setLoading(false);
    if (result.success) {
      changeDraftInRow(draft);
      dismissModal();
    } else {
      showErrorToast('Failed to update draft', 'update-draft-error');
    }
  }
  const onPrimaryButtonClick = () => {
    if (isDirty || submitOnNotDirty) {
      onSubmit(submit);
    } else {
      dismissModal();
    }
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: title,
    "data-testid": testid,
    content: content,
    width: width,
    skin: skin,
    primaryButtonLabel: primaryButtonLabel,
    secondaryButtonLabel: "Cancel",
    onCloseButtonClick: dismissModal,
    onSecondaryButtonClick: dismissModal,
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonLoading: loading,
    primaryButtonTestid: "".concat(testid, "-confirm"),
    textAlignCenter: false
  });
}